<template>
  <div class="mb-2">
    <b-button v-on="$listeners"
              block
              class="hide-details-button my-1 rounded-0"
              data-testid="block-button"
              variant="info">

      <base-material-design-icon class="white--text"
                                 icon="expand_less"/>

      <span v-text="buttonText"/>

      <base-material-design-icon class="white--text"
                                 icon="expand_less"/>
    </b-button>
  </div>
</template>

<script>
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseCollapseBlockButton',
    components: { BaseMaterialDesignIcon },
    props: {
      buttonText: {
        type: String,
        default: 'Collapse',
      },
    },
  };
</script>

<style scoped>

  .hide-details-button {
    display: flex;
    justify-content: space-between;
  }

</style>
